export function useGetUniqueId(prefix) {
	let id = Math.random().toString(36).substring(3, 10)
	id = `${prefix}-${id}`

	const exists = document.querySelector(id)
	if (exists) {
		return this.GetUniqueId()
	}

	return id
}
